<script setup>
import { ref, computed, onBeforeMount } from 'vue';
import { useStore } from 'vuex';
import SignupForm from './components/Signup/Form.vue';
import Spinner from 'shared/components/Spinner.vue';

const store = useStore();

const isLoading = ref(false);
const globalConfig = computed(() => store.getters['globalConfig/get']);
const isAOSDeskInstance = computed(
  () => globalConfig.value.installationName === 'OS Desk'
);
</script>

<template>
  <div
    class="bg-surface text-on-surface font-body-md overflow-hidden selection:bg-secondary-container h-screen flex flex-col"
  >
    <main class="h-screen overflow-hidden flex flex-col flex-grow">
      <SignupForm v-show="!isLoading" />
      <div
        v-show="isLoading"
        class="relative z-10 flex items-center justify-center w-full h-full min-h-[400px] flex-grow"
      >
        <Spinner color-scheme="primary" />
      </div>
    </main>
  </div>
</template>
